import { useState } from 'react';
import { verifyPassword } from '../lib/server';
import { APP_VERSION } from '../version';

// Shown only when the app is password-gated (a server voice/transcription of ours
// is available and protected). One shared password, no username.

export default function Gate({ onUnlock }: { onUnlock: () => void }) {
  const [pw, setPw] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(false);

  async function submit(e?: React.FormEvent) {
    e?.preventDefault();
    if (!pw.trim() || busy) return;
    setBusy(true);
    setErr(false);
    const ok = await verifyPassword(pw.trim());
    setBusy(false);
    if (ok) onUnlock();
    else {
      setErr(true);
      setPw('');
    }
  }

  return (
    <div className="stage">
      <div className="frame">
        <section className="screen-setup" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: 620 }}>
          <div className="eyebrow">Speaking practice</div>
          <h1 className="setup-title">Enter the access password</h1>
          <p className="setup-sub">
            This practice room runs on a shared voice. Enter the password to continue — or you can add your own API key
            after, and it'll work without one.
          </p>
          <form onSubmit={submit} style={{ maxWidth: 360 }}>
            <div className="field">
              <input
                type="password"
                autoFocus
                autoComplete="current-password"
                placeholder="Password"
                value={pw}
                onChange={(e) => { setPw(e.target.value); setErr(false); }}
                aria-invalid={err}
                aria-label="Access password"
              />
              {err && <div className="hint" style={{ color: 'var(--danger)' }}>That password didn't match. Try again.</div>}
            </div>
            <div className="start-row" style={{ marginTop: 8 }}>
              <button className="btn-primary" type="submit" disabled={busy || !pw.trim()}>
                {busy ? 'Checking…' : 'Enter'}
              </button>
            </div>
          </form>
          <div className="vstr">v{APP_VERSION}</div>
        </section>
      </div>
    </div>
  );
}
